export const paymentKeys = {
  all: ["payments"],
  lists: () => [...paymentKeys.all, "list"],
  list: (params = {}) => [...paymentKeys.lists(), params],
  finance: () => [...paymentKeys.lists(), "finance"],
  chapterList: () => [...paymentKeys.lists(), "chapter"],
  details: () => [...paymentKeys.all, "detail"],
  detail: (id) => [...paymentKeys.details(), id],
};
